$(".burger").click(function () {
    $(".header").toggleClass("_open")
    $("body").toggleClass("fixed-body")
})

$(".menu-tablet__show").click(function() {
    $(this).parents(".menu-tablet").toggleClass("_open")
})

$(".main").click(function() {
    $(".m-dropdown,.menu-tablet,.header").removeClass("_open")
})

$(".m-dropdown__show").click(function() {
    if($(this).parents(".m-dropdown").hasClass("_open")){
        $(".m-dropdown").removeClass("_open")
    } else{
        $(".m-dropdown").removeClass("_open")
        $(this).parents(".m-dropdown").addClass("_open")
    }
})

$(document).mouseup( function(e){
    let div = $( ".m-dropdown,.menu-tablet,.header" );
    if ( !div.is(e.target)
        && div.has(e.target).length === 0 ) {
        if($(div).hasClass("_open")){
            $(div).removeClass("_open")
        }
    }
});
